import { render } from "./App.vue?vue&type=template&id=b3aaa346"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b3aaa346&lang=scss"

import exportComponent from "/builds/rgLPqy5NH/0/rockwool/super-wykonawca-2022/performer-rating-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__